import React, { useState, useRef } from "react";

function SearchBar({ onSearch }) {
  const [value, setValue] = useState("");
  const timerRef = useRef(null);

  const handleChange = (e) => {
    const v = e.target.value;
    setValue(v);
    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => onSearch(v), 400);
  };

  return (
    <div className="search-bar">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <circle cx="11" cy="11" r="8" />
        <line x1="21" y1="21" x2="16.65" y2="16.65" />
      </svg>
      <input
        type="text"
        placeholder="חיפוש הודעות..."
        value={value}
        onChange={handleChange}
      />
    </div>
  );
}

export default SearchBar;
